import styled from 'styled-components';
import { Form } from 'antd';
import { color, font } from 'shared/utils/styles';
import { Table, Button } from 'shared/components';

export const HaierOrderTable = styled.div`
  overflow-x: auto;

  & .ant-tabs-tab {
    padding: 0 10px 10px 0;
    margin: 0;

    &.ant-tabs-tab-active {
      margin: 0;
    }
  }
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0px;
`;

export const StyledContainerButton = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 10px;
`;

export const StyledButton = styled(Button)`
  &.ant-btn {
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
`;

export const TextTotalPrice = styled.span`
  ${font.bold}
  ${font.size(24)}
  color: ${color.danger}
`;

export const TextTotalRevenue = styled.span`
  ${font.bold}
  ${font.size(24)}
  color: ${color.success}
`;

export const StyledTable = styled(Table)`
  & th.ant-table-cell {
    white-space: nowrap;
  }

  &.table-1 {
    & .ant-table-thead tr:nth-child(2) th:not(:first-child):not(:nth-child(2)):not(:last-child) {
      border-right: 0 !important;
    }

    & .ant-table-tbody td:not(:first-child):not(:nth-child(2)):not(:last-child) {
      border-right: 0 !important;
    }
  }

  &.table-2 {
    & .ant-table-thead tr:nth-child(2) th:not(:first-child):not(:last-child) {
      border-right: 0 !important;
    }

    & .ant-table-tbody td:not(:first-child):not(:last-child) {
      border-right: 0 !important;
    }
  }
`;
